// extracted by mini-css-extract-plugin
module.exports = {"popup-box":"styles_popup-box__23v-l","box":"styles_box__1pCGb","close-icon":"styles_close-icon__6p5VR"};